import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useSignUpMutation } from '../slices/usersApiSlice';
import { toast } from 'react-toastify';
import FormContainer from '../components/FormContainer';
import Loader from '../components/Loader';
import Message from '../components/Message';


export default function SignUpScreen() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    primaryEmail: '',
    password: '',
    confirmPassword: ''
  });

  const { 
    firstName,
    lastName,
    primaryEmail,
    password,
    confirmPassword
  } = formData
  
  const navigate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);

  const [signUp, { isLoading: isSigningUp }] = useSignUpMutation();
  const [localError, setLocalError] = useState('');

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const redirect = searchParams.get('redirect') || '/';

  useEffect(() => { 
      if (userInfo) { 
        navigate(redirect);
      }
    }, [userInfo, redirect, navigate]
  );

  const signUpHandler = async (e) => { 
    e.preventDefault();
    if (password !== confirmPassword) { 
      toast.error("Error: Passwords do not match");
      return;
    } else { 
      try {
      await signUp({ 
        firstName, 
        lastName, 
        primaryEmail, 
        password 
      }).unwrap();
      toast.success("Success: Verification e-mail sent. Please, check your inbox to continue signing in.");
      navigate("/verify_e-mail_notice");
      } catch (err) {
        const msg =
          err?.data?.message ||
          err.error ||
          "Error: Invalid input. Correct and try again.";
        setLocalError(msg);
      }
    }
  };

  return ( 
    <FormContainer>
      <h1>Sign Up</h1>
      <h5>* = Required field</h5>
      {isSigningUp && <Loader />}
      {localError && <Message variant="danger">{localError}</Message>}
      <Form onSubmit={ signUpHandler }>
        <Form.Group controlId='firstName' className='my-4'>
          <Form.Label>*First Name:</Form.Label>
          <Form.Control
            type='text'
            placeholder='Your first name'
            value={firstName}
            onChange={(e) => {
              if (localError) setLocalError('');
              setFormData({ ...formData, firstName: e.target.value });
            }}
          ></Form.Control>
        </Form.Group>
        <Form.Group controlId='lastName' className='my-4'>
          <Form.Label>*Last Name:</Form.Label>
          <Form.Control
            type='text'
            placeholder='Your last name'
            value={lastName}
            onChange={(e) => {
              if (localError) setLocalError('');
              setFormData({ ...formData, lastName: e.target.value }); 
            }}
          ></Form.Control>
        </Form.Group>
        <Form.Group controlId='primaryEmail' className='my-4'>
          <Form.Label>*E-mail Address:</Form.Label>
          <Form.Control
            type='email'
            placeholder='Your best e-mail address'
            value={primaryEmail}
            onChange={(e) => {
              if (localError) setLocalError('');
              setFormData({ ...formData, primaryEmail: e.target.value });
            }}
          ></Form.Control>
        </Form.Group>
        <Form.Group controlId='password' className='my-4'>
          <Form.Label>*Password:</Form.Label>
          <Form.Control
            type='password'
            placeholder='Your password'
            value={password}
            onChange={(e) => {
              if (localError) setLocalError('');
              setFormData({ ...formData, password: e.target.value });
            }}
          ></Form.Control>
        </Form.Group>
        <Form.Group controlId='confirmPassword' className='my-4'>
          <Form.Label>*Confirm Password:</Form.Label>
          <Form.Control
            type='password'
            placeholder='Confirm password above'
            value={confirmPassword}
            onChange={(e) => {
              if (localError) setLocalError('');
              setFormData({ ...formData, confirmPassword: e.target.value })
            }}
          ></Form.Control>
        </Form.Group>
        <Button 
          type='submit' 
          variant='primary' 
          className='mt-4'
          disabled={ isSigningUp }
        >
          Sign Up
        </Button>
        { isSigningUp && <Loader /> }
      </Form>
      <Row className='py-4'>
        <Col>
          Already signed up? <Link to={ 
            redirect 
              ? `/sign_in?redirect=${redirect}` 
              : "/sign_in"
          }>Sign In</Link>
        </Col>
      </Row>
    </FormContainer>
  );
};